/* unplugin-vue-components disabled */import { render } from "./shipments.vue?vue&type=template&id=474da021&scoped=true"
import script from "./shipments.vue?vue&type=script&lang=js"
export * from "./shipments.vue?vue&type=script&lang=js"

import "./shipments.vue?vue&type=style&index=0&id=474da021&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474da021"]])

export default __exports__